<script>
const sidebarMenu = [
  { path: '/dashboard', icon: 'fa fa-sitemap', title: 'Dashboard'},
]

export default sidebarMenu;
</script>
